import type { FaireProductEntity } from "../../entity_types/product";

export const p_uf82xxnagn: FaireProductEntity = {
  token: "p_uf82xxnagn",
  type: "product",
  name: "Pink Forever and Ever Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/949ded9b776595b299aa211b869d5ce717952856f55a73c09ad47738b0cac68c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9f6b28ff25f236a35d72cd8aa3e3471e1c586ab493f6fccfa40906388abb07b9.jpeg",
    "https://cdn.faire.com/fastly/6b7c5486b8ccf12e3c303227639daa71ece3a1ae53aa254b59c54acd42d2ef05.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:23.479Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
